module.exports = __webpack_public_path__ + "static/media/englishBoard.e491f642.png";